import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onConfirm", "confirmButtonProps", "rejectUse"];
import { useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { useTheme } from 'foundations-theming/utils';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { useIsPreview } from '../../hooks/useIsPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export const PortalConfirmModal = _ref => {
  let {
      onConfirm,
      confirmButtonProps,
      rejectUse = 'secondary-alt'
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isPreview = useIsPreview();
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  const theme = useTheme();
  const overrideTheme = useMemo(() => Object.assign({}, theme, {
    borderRadius: Object.assign({}, theme.borderRadius, {
      'transitional-floating': theme.borderRadius['0']
    })
  }), [theme]);

  // In HubSpot's theme preview the app runs inside a sandboxed iframe
  // without allow-forms. ConfirmDialog's confirm button is type="submit"
  // and fires onConfirm via the form's onSubmit handler, which the browser
  // blocks in that context. In preview mode we override the button to
  // type="button" with a direct onClick so the handler fires regardless.
  // Note: the onClick calls onConfirm directly, so callers must ensure
  // onConfirm already includes modal-dismiss logic. useConfirmModal guarantees
  // this — use PortalConfirmModal via useConfirmModal, not standalone.
  const resolvedConfirmButtonProps = isPreview ? Object.assign({}, confirmButtonProps, {
    type: 'button',
    onClick: evt => {
      evt.stopPropagation();
      onConfirm === null || onConfirm === void 0 || onConfirm();
    }
  }) : confirmButtonProps;
  const modal = /*#__PURE__*/_jsx(ConfirmModal, Object.assign({}, props, {
    onConfirm: isPreview ? undefined : onConfirm,
    confirmButtonProps: resolvedConfirmButtonProps,
    rejectUse: rejectUse
  }));
  if (!isUsingPillBorderRadius) return modal;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: overrideTheme,
    children: modal
  });
};